export default __webpack_public_path__ + "static/media/Anuphan-Regular.b9f4f346.ttf";